import { SearchCategoryFilter, SearchResultCategory } from "./GlobalSearch.Types";

export interface SearchCategoryFilterConfig {
  id: SearchCategoryFilter;
  label: string;
}

// Add a category here once it's indexed (e.g. Settings) — nothing else changes.
export const SEARCH_CATEGORY_FILTERS: SearchCategoryFilterConfig[] = [
  { id: "all", label: "All" },
  { id: SearchResultCategory.LOCATION, label: SearchResultCategory.LOCATION },
  { id: SearchResultCategory.DETAILS_V3, label: SearchResultCategory.DETAILS_V3 },
  { id: SearchResultCategory.POLICY, label: SearchResultCategory.POLICY },
  { id: SearchResultCategory.REPORT, label: SearchResultCategory.REPORT }
];
